
import { Vue } from 'vue-class-component';
import { ElMessage } from 'element-plus';
import CreateServiceConfigModel from '@/models/createServiceConfigModel';
import ErrorCode from '@/constants/ErrorCode';
import CommonValidate from '@/services/commonValidate';
import ServiceCodeService from '../services/serviceCodeService';

export default class Resource extends Vue {
 private resources=[];

 private dialogVisible=false;

 private model=new CreateServiceConfigModel();

private validate = (rule:any, value:any, callback:any) => {
  if (!/^[A-Za-z]{1,10}$/.test(value)) {
    callback(new Error('资源编码必须是字母且长度1至10'));
  } else {
    callback();
  }
};

 private rules= {
   serviceCode: [
     { required: true, message: '请输入资源编码', trigger: 'blur' },
     { validator: this.validate, trigger: 'blur' },
   ],
   description: [
     { required: true, message: '请输入资源描述', trigger: 'blur' },
     { validator: CommonValidate.validateDesc, trigger: 'blur' },
   ],
 };

 mounted() {
   this.loadData();
 }

 loadData(): void {
   ServiceCodeService.getAll().then((result) => {
     if (result.code === ErrorCode.Success) {
       this.resources = result.data;
     }
   }).catch((response) => {
     console.log(response);
   });
 }

 save():void {
   const form:any = this.$refs.createform;
   form.validate((valid:boolean) => {
     if (valid) {
       ServiceCodeService.create(this.model).then((response) => {
         if (response.code === ErrorCode.Success) {
           ElMessage.success(response.msg);
           this.loadData();
           form.resetFields();
           this.dialogVisible = false;
         } else {
           ElMessage.error(response.msg);
         }
       });
     }
   });
 }
}
